/*
 * File: Provider.js
 * Project: mp-mobile-app
 *
 * Created by Sam Hookstra on 12/31/2019
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: MST Store for Providers
 */
import { types } from "mobx-state-tree";

const Provider = types
  .model({
    firstName: types.maybe(types.string),
    lastName: types.maybe(types.string),
    userId: types.maybe(types.number),
    uniqueId: types.maybe(types.string),
    professionalTitle: types.maybe(types.string)
  })
  .views(self => ({
    get fullName() {
      return self.lastName + ", " + self.firstName;
    }
  }));

export default Provider;
